import { DomService } from '../../services/dom';

export const getElementSizes = (element: HTMLElement): number[] => {
  const computedStyle = getComputedStyle(element);

  const sizesDefinition = computedStyle.getPropertyValue('--responsive-container') || (computedStyle['-ie-responsive-container'] as string);

  return (sizesDefinition || '')
    .replace(/\$/g, '')
    .split(',')
    .filter((size) => size)
    .map((size) => parseInt(size.trim(), 10));
};

export const responsive = (element: HTMLElement, prop = 'component-width', toObserve: HTMLElement = element, callback?: () => void) => {
  const sizes = getElementSizes(element);

  DomService.createObserver(
    toObserve,
    ([
      {
        contentRect: { width },
      },
    ]) => {
      const size = (sizes.find((item) => item < width) || 0).toString();

      if (element.getAttribute(prop) !== size) {
        element.setAttribute(prop, size);
      }

      if (callback) {
        callback();
      }
    },
  );
};
